export declare namespace AppEventGroupTokenSections {
	interface GroupHeader {
		color: string;
		fontWeight: string;
		fontSize: string;
		lineHeight: string;
	}

	interface Row {
		background: string;
	}

	interface Date {
		color: string;
		fontWeight: string;
		fontSize: string;
	}

	interface Abbreviation {
		color: string;
		fontWeight: string;
		fontSize: string;
	}

	interface Deadline {
		color: string;
		fontSize: string;
	}
}

export type AppEventGroupTokens = {
	groupHeader: AppEventGroupTokenSections.GroupHeader;
	row: AppEventGroupTokenSections.Row;
	date: AppEventGroupTokenSections.Date;
	abbreviation: AppEventGroupTokenSections.Abbreviation;
	deadline: AppEventGroupTokenSections.Deadline;
};

export const groupHeader: AppEventGroupTokenSections.GroupHeader = {
	color: '{text.color}',
	fontWeight: '600',
	fontSize: '0.875rem',
	lineHeight: '1.5rem',
};

export const row: AppEventGroupTokenSections.Row = {
	background: '{surface.50}',
};

export const date: AppEventGroupTokenSections.Date = {
	color: '{text.color}',
	fontWeight: '600',
	fontSize: '0.875rem',
};

export const abbreviation: AppEventGroupTokenSections.Abbreviation = {
	color: '{text.color}',
	fontWeight: '500',
	fontSize: '0.875rem',
};

export const deadline: AppEventGroupTokenSections.Deadline = {
	color: '{surface.300}',
	fontSize: '0.875rem',
};

export default {
	groupHeader,
	row,
	date,
	abbreviation,
	deadline,
} satisfies AppEventGroupTokens;
